import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowRight, FaTimes, FaFire } from 'react-icons/fa';

// Rotating pre-sale messages shown in the sticky top bar.
const MESSAGES = [
  'offers.popup.kids',
  'offers.popup.adults',
  'offers.popup.individual',
  'offers.popup.daily',
];
const ROTATE_MS = 3500;

export default function TopOfferBar() {
  const { t } = useTranslation();
  const [i, setI] = useState(0);
  const [closed, setClosed] = useState(
    () => typeof window !== 'undefined' && sessionStorage.getItem('topOfferBarClosed') === '1'
  );

  useEffect(() => {
    if (closed) return undefined;
    const id = setInterval(() => setI((p) => (p + 1) % MESSAGES.length), ROTATE_MS);
    return () => clearInterval(id);
  }, [closed]);

  if (closed) return null;

  const close = () => {
    setClosed(true);
    try { sessionStorage.setItem('topOfferBarClosed', '1'); } catch (e) { /* ignore */ }
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1050,
        background: 'linear-gradient(90deg, #1530b8 0%, #1D3EE3 50%, #2f57f0 100%)',
        color: '#fff',
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center gap-2 gap-md-3"
        style={{ minHeight: '46px', position: 'relative', flexWrap: 'nowrap', paddingLeft: '16px', paddingRight: '42px' }}
      >
        <FaFire size={16} style={{ flexShrink: 0, color: '#ffd34d' }} />

        {/* Rotating message */}
        <div
          className="d-flex align-items-center gap-2 text-truncate"
          style={{ minWidth: 0 }}
        >
          <span
            key={i}
            className="top-offer-msg fw-bold text-truncate"
            style={{ fontSize: '0.95rem' }}
          >
            {t(MESSAGES[i])}
          </span>
          <span
            className="d-none d-lg-inline text-nowrap"
            style={{ fontSize: '0.82rem', opacity: 0.85 }}
          >
            · {t('offers.popup.deadline')}
          </span>
        </div>

        {/* CTA button */}
        <Link
          to="/ofertat"
          className="d-inline-flex align-items-center gap-1 fw-bold text-nowrap"
          style={{
            flexShrink: 0,
            backgroundColor: '#fff',
            color: '#1D3EE3',
            borderRadius: '999px',
            padding: '6px 14px',
            fontSize: '0.85rem',
            textDecoration: 'none',
            boxShadow: '0 3px 10px rgba(0,0,0,0.18)',
          }}
        >
          {t('offers.popup.cta')} <FaArrowRight size={11} />
        </Link>

        {/* Close */}
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="d-flex align-items-center justify-content-center"
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '26px',
            height: '26px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: 'rgba(255,255,255,0.18)',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          <FaTimes size={12} />
        </button>
      </div>
    </div>
  );
}
